import axios from 'axios';
import {
  API_URL,
  SHOW_RIGHTSHIP_REPORT_BY_PORTS,
  GET_RIGHTSHIP_CHART_DATA_BY_PORTS
} from './ConstantService';

export const FindingsByPortService = {
  showRightshipReport(params = {}) {
    return axios.post(SHOW_RIGHTSHIP_REPORT_BY_PORTS, { params });
  },
  getRsFindingByPortsCharts(params = {}){
    return axios.post(GET_RIGHTSHIP_CHART_DATA_BY_PORTS, { params });
  },
};
